import { ComparatorContainer } from './ComparatorContainer'
import { ComparatorDateInput } from './ComparatorDateInput'
import { ComparatorInput } from './ComparatorInput'
import { ComparatorOperation } from './ComparatorOperation'
import { ComparatorOperationInput } from './ComparatorOperationInput'
import {
  ComparatorType,
  useComparatorOperations,
} from './hooks/useComparatorOperations'
import { useFallbackComparator } from './hooks/useFallbackComparator'
import { isNegation } from './utils/isNegation'

const Comparator = () => null

Comparator.Container = ComparatorContainer
Comparator.Input = ComparatorInput
Comparator.DateInput = ComparatorDateInput
Comparator.OperationInput = ComparatorOperationInput
Comparator.Operation = ComparatorOperation

export type { ComparatorType }
export {
  Comparator,
  useComparatorOperations,
  useFallbackComparator,
  isNegation,
}
